import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getSegmentDetailApi,
  updateSegmentDetailApi,
} from "designs/v1/pages/ModifyKyc/services";

const CheckPrevRequest = ({
  stageScreen,
  setStageScreen,
  setStep,
  isContinue,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [exchangeSegment, setExchangeSegment] = useState([]);
  const [tradingPreference, setTradingPreference] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [disabledList, setDisabledList] = useState([]);

  useEffect(() => {
    const loadSegment = async () => {
      setIsLoading(true);
      try {
        const resp = await getSegmentDetailApi({ request_type: stageScreen });
        setExchangeSegment(resp.data.data.exchange_segment);
        setIsLoading(false);
      } catch (error) {
        console.log("err", error);
        setIsLoading(false);
      }
    };
    loadSegment();
  }, [stageScreen]);

  useEffect(() => {
    const payload = exchangeSegment.map((item) => {
      return {
        exchange: item.exchange,
        cash: false,
        fno: false,
        currency_derivatives: false,
        commodities: false,
        slb: false,
      };
    });
    setTradingPreference(payload);
  }, [exchangeSegment]);

  const segmentType = (type) => {
    let str = "";
    switch (type) {
      case "nse":
        str = "cash";
        break;
      case "bse":
        str = "fno";
        break;
      case "msei":
        str = "currency_derivatives";
        break;
      case "ncdex":
        str = "commodities";
        break;
      case "mcx":
        str = "slb";
        break;
      default:
    }
    return str;
  };

  const getSegment = (segment, segmentArr) => {
    let reduce = segmentArr.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [segmentType(item.exchange)]: item.value === 1 ? true : false,
        }),
      {}
    );
    return { exchange: segment, ...reduce };
  };

  const getSegmentName = (name) => {
    let str = "";
    switch (name) {
      case "Capital Market":
        str = "NSE";
        break;
      case "Future and Option":
        str = "BSE";
        break;
      case "Currency Derivative":
        str = "MSEI";
        break;
      case "Commodities":
        str = "NCDEX";
        break;
      case "SLB":
        str = "MCX";
        break;
      default:
    }
    return str;
  };

  const getSegmentKey = (segmentArr, key) => {
    let cashResp = segmentArr.map((y) => {
      return {
        exchange: getSegmentName(y.segment).toLowerCase(),
        value: y[key],
      };
    });
    return cashResp;
  };

  useEffect(() => {
    if (exchangeSegment.length > 0 && activeUserDetail.product?.length > 0) {
      console.log("segment", activeUserDetail.product);
      let nse = getSegment("NSE", getSegmentKey(activeUserDetail.product, "nse"));
      let bse = getSegment("BSE", getSegmentKey(activeUserDetail.product, "bse"));
      let msei = getSegment("MSEI", getSegmentKey(activeUserDetail.product, "msei"));
      let ncdex = getSegment("NCDEX", getSegmentKey(activeUserDetail.product, "ncdex"));
      let mcx = getSegment("MCX", getSegmentKey(activeUserDetail.product, "mcx"));
      setTradingPreference([nse, bse, msei, ncdex, mcx]);
    }
  }, [exchangeSegment, activeUserDetail]);

  const findExchangeAndSegment = (arr, toFindExchange, toFindSegment) => {
    const found = arr.find((item) => {
      return item.exchange === toFindExchange;
    });
    if (found) {
      return found[toFindSegment];
    }
    return undefined;
  };

  const segmentLabels = {
    CAPITAL_MARKET: "Capital Market",
    FUTURES_AND_OPTIONS: "Future and Option",
    CURRENCY_DERIVATIVES: "Currency Derivative",
    COMMODITIES: "Commodities",
    SLB: "SLB",
  };

  const segmentTypes = {
    CASH: "cash",
    FNO: "fno",
    CURRENCY_DERIVATIVES: "currency_derivatives",
    COMMODITIES: "commodities",
    SLB: "slb",
  };

  const exchangeTypes = {
    BSE: "BSE",
    NSE: "NSE",
    MSEI: "MSEI",
    NCDEX: "NCDEX",
    MCX: "MCX",
  };

  const segments = [
    { label: segmentLabels.CAPITAL_MARKET, type: segmentTypes.CASH },
    { label: segmentLabels.FUTURES_AND_OPTIONS, type: segmentTypes.FNO },
    {
      label: segmentLabels.CURRENCY_DERIVATIVES,
      type: segmentTypes.CURRENCY_DERIVATIVES,
    },
    { label: segmentLabels.COMMODITIES, type: segmentTypes.COMMODITIES },
    { label: segmentLabels.SLB, type: segmentTypes.SLB },
  ];

  const conversionFunction = (arr) => {
    const newArray = segments.map((item) => {
      return {
        segment: item.label,
        bse: findExchangeAndSegment(arr, exchangeTypes.BSE, item.type),
        nse: findExchangeAndSegment(arr, exchangeTypes.NSE, item.type),
        msei: findExchangeAndSegment(arr, exchangeTypes.MSEI, item.type),
        ncdex: findExchangeAndSegment(arr, exchangeTypes.NCDEX, item.type),
        mcx: findExchangeAndSegment(arr, exchangeTypes.MCX, item.type),
      };
    });
    return newArray;
  };

  const handleSubmit = async () => {
    let segments = conversionFunction(tradingPreference);
    segments = segments.filter(
      (item) => item.nse || item.bse || item.mcx || item.msei || item.ncdex
    );
    if (segments.length === 0) {
      return toast.error("Error: Please select atleast one Segment.");
    }
    setIsLoading(true);
    const payload = {
      request_type: stageScreen,
      document_name: localStorage.getItem("SegmentRequestNumber"),
      segment_detail: segments,
    };
    console.log("payload", payload);
    try {
      const resp = await updateSegmentDetailApi(payload);
      console.log(resp.data);
      toast.success(resp.data.message?.message);
      setIsLoading(false);
      let showIncomeProof = false;
      payload.segment_detail.forEach((element) => {
        if (element.segment === "Capital Market") {
          if (element.mcx || element.ncdex) {
            showIncomeProof = true;
          }
        }
        if (element.segment === "Currency Derivative") {
          if (
            element.bse ||
            element.nse ||
            element.ncdex ||
            element.mcx ||
            element.ncdex
          ) {
            showIncomeProof = true;
          }
        }
        if (element.segment === "SLB") {
          if (
            element.bse ||
            element.nse ||
            element.ncdex ||
            element.mcx ||
            element.ncdex
          ) {
            showIncomeProof = true;
          }
        }
        if (element.segment === "Commodities") {
          if (
            element.bse ||
            element.nse ||
            element.ncdex ||
            element.mcx ||
            element.ncdex
          ) {
            showIncomeProof = true;
          }
        }
        if (element.segment === "Future and Option") {
          if (
            element.bse ||
            element.nse ||
            element.ncdex ||
            element.mcx ||
            element.ncdex
          ) {
            showIncomeProof = true;
          }
        }
      });
      if (showIncomeProof) {
        setStep("IncomeModification");
      } else {
        setStep("SegmentModificationReview");
      }
      setIsContinue(false);
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data?.message?.message || "Internal server error!");
      setIsLoading(false);
    }
  };
  const isSegmentField = (segment, key) => {
    let showSegment = false;
    for (let i in segment) {
      if (segment[i][key] === 1) {
        showSegment = true;
      }
    }
    return showSegment;
  };

  const getCheckboxValue = (exchange, key) => {
    let temp = [...tradingPreference];
    let val = false;
    for (let i in temp) {
      if (temp[i].exchange === exchange) {
        val = temp[i][key];
      }
    }
    return val;
  };

  const getCheckboxValueNew = (exchange, key) => {
    let temp = [...tradingPreference];
    let val = false;
    for (let i in temp) {
      if (temp[i].exchange === exchange) {
        val = temp[i][key];
      }
    }
    return val;
  };

  const setCheckboxValue = (exchange, key) => {
    setTradingPreference((prevPreference) => {
      return prevPreference.map((item) => {
        if (item.exchange === exchange) {
          return {
            ...item,
            [key]: !item[key],
            [key + 1]: !item[key],
          };
        }
        return item;
      });
    });
  };

  useEffect(() => {
    if (!isDisabled) {
      setDisabledList([...tradingPreference]);
    }
  }, [tradingPreference, isDisabled]);

  const isDisbaled = (item, type) => {
    return (
      getCheckboxValue(item.exchange, type) &&
      !getCheckboxValueNew(item.exchange, type + 1)
    );
  };

  const isSubmit = () => {
    const filter = tradingPreference?.filter(
      (item) =>
        item?.cash1 ||
        item?.fno1 ||
        item?.currency_derivatives1 ||
        item?.commodities1 ||
        item?.slb1
    );
    return !filter?.length;
  };

  return (
    <div>
      <Title title="Segment Modification" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          <table className="table mx-2">
            <thead>
              <tr>
                <th scope="col">Segment</th>
                {isSegmentField(exchangeSegment, "cash") && <th>Capital Market</th>}
                {isSegmentField(exchangeSegment, "fno") && <th>Future And Option</th>}
                {isSegmentField(exchangeSegment, "currency_derivatives") && (
                  <th>Currency Derivative</th>
                )}
                {isSegmentField(exchangeSegment, "commodities") && <th>Commodities</th>}
                {isSegmentField(exchangeSegment, "slb") && <th>SLB</th>}
              </tr>
            </thead>
            <tbody>
              {exchangeSegment.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.exchange}</td>
                    {isSegmentField(exchangeSegment, "cash") && (
                      <td>
                        {item.cash === 1 && (
                          <input
                            type="checkbox"
                            checked={getCheckboxValue(item.exchange, "cash")}
                            onChange={() => {
                              // setIsDisabled(true);
                              setCheckboxValue(item.exchange, "cash");
                            }}
                            disabled={isDisbaled(item, "cash")}
                            // disabled={
                            //   disabledList.filter((item) => item.cash)?.length !== 0
                            // }
                          />
                        )}
                      </td>
                    )}
                    {isSegmentField(exchangeSegment, "fno") && (
                      <td>
                        {item.fno === 1 && (
                          <input
                            type="checkbox"
                            checked={getCheckboxValue(item.exchange, "fno")}
                            onChange={() => {
                              // setIsDisabled(true);
                              setCheckboxValue(item.exchange, "fno");
                            }}
                            disabled={isDisbaled(item, "fno")}
                            // disabled={
                            //   disabledList.filter((item) => item.fno)?.length !== 0
                            // }
                          />
                        )}
                      </td>
                    )}
                    {isSegmentField(exchangeSegment, "currency_derivatives") && (
                      <td>
                        {item.currency_derivatives === 1 && (
                          <input
                            type="checkbox"
                            checked={getCheckboxValue(
                              item.exchange,
                              "currency_derivatives"
                            )}
                            onChange={() => {
                              // setIsDisabled(true);
                              setCheckboxValue(item.exchange, "currency_derivatives");
                            }}
                            disabled={isDisbaled(item, "currency_derivatives")}
                            // disabled={
                            //   disabledList.filter((item) => item.currency_derivatives)
                            //     ?.length !== 0
                            // }
                          />
                        )}
                      </td>
                    )}
                    {isSegmentField(exchangeSegment, "commodities") && (
                      <td>
                        {item.commodities === 1 && (
                          <input
                            type="checkbox"
                            checked={getCheckboxValue(item.exchange, "commodities")}
                            onChange={() => {
                              // setIsDisabled(true);
                              setCheckboxValue(item.exchange, "commodities");
                            }}
                            disabled={isDisbaled(item, "commodities")}
                            // disabled={
                            //   disabledList.filter((item) => item.commodities)?.length !==
                            //   0
                            // }
                          />
                        )}
                      </td>
                    )}
                    {isSegmentField(exchangeSegment, "slb") && (
                      <td>
                        {item.slb === 1 && (
                          <input
                            type="checkbox"
                            checked={getCheckboxValue(item.exchange, "slb")}
                            onChange={() => {
                              // setIsDisabled(true);
                              setCheckboxValue(item.exchange, "slb");
                            }}
                            disabled={isDisbaled(item, "slb")}
                            // disabled={
                            //   disabledList.filter((item) => item.slb)?.length !== 0
                            // }
                          />
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!isLoading && (
            <div className="d-flex mt-4">
              <div className="ml-2">
                <Button
                  title="Back"
                  type="button"
                  handleClick={() => {
                    setStep(isContinue ? "CheckPrevRequest" : "DematUccForm");
                    setIsContinue(false);
                  }}
                  loading={isLoading}
                />
              </div>
              <div className="mx-2">
                <Button
                  title="Submit"
                  handleClick={() => handleSubmit()}
                  loading={isLoading}
                  // disabled={isSubmit()}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckPrevRequest;
